import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DrugsApi } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';

export const useUpdateInstruction = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DrugsApi.updateInstruction,
    onSuccess: async (_, params) => {
      await queryClient.invalidateQueries(DrugsQueryKeys.getInstructionKey(params.drug_id));
    },
  });
};
